<ion-item>

  <ion-label>{{ 'ITEMS.WAREHOUSE.COST' | translate }}</ion-label>

  <ion-note slot="end">
    {{ (cost | currency: 'EUR': 'symbol': '1.2-2': 'es') || '- €' }}
  </ion-note>

</ion-item>
